import request from "../request";

export const fetchPractitionerAvailabilityFromApi = async ({ specialistUserId, month, appointmentType, timezone }) => {
  try {
    const response = await request.get("/pms/admin/availability", {
      params: {
        specialistUserId,
        month,
        appointmentType,
        timezone,
      },
    });

    return response.data?.data ?? [];
  } catch (error) {
    console.error("Error fetching practitioner availability:", error);
    throw error;
  }
};
